import { useEffect, useState } from "react";
import { getNews, NewsResponse } from "../../../api/news";
import HotNews from "./component/HotNews";
import NormalNews from "./component/News";
import {
  NewsWrapper,
  Content,
  ReadMoreContainer,
  Line,
  ReadMoreButton,
  Header,
} from "./style";
import { insetState } from "../../../recoil/inset";
import { useRecoilValue } from "recoil";
import { useHistory } from "react-router-dom";

const News = () => {
  const [hotNewsList, setHotNewsList] = useState<NewsResponse[]>([]);
  const [newsList, setNewsList] = useState<NewsResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [count, setCount] = useState(0);
  const size = 10;
  const inset = useRecoilValue(insetState);
  const history = useHistory();

  const getNewList = async () => {
    const allNews = await getNews(currentPage, size, 2);
    if (newsList.length > 0) {
      setNewsList((prevNewsList) => [...prevNewsList, ...allNews.news]);
      setHotNewsList(allNews.hotNews);
      return;
    }
    setHotNewsList(allNews.hotNews);
    setNewsList(allNews.news);
    setCount(allNews.totalElements);
  };

  useEffect(() => {
    getNewList();
  }, [currentPage]);

  return (
    <NewsWrapper isApp={inset}>
      <Header isApp={inset}>
        <div className="close" onClick={() => history.push("/")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 19L5 12M5 12L12 5M5 12H19"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="title">홀덤 뉴스</div>
      </Header>
      <Content>
        <HotNews list={hotNewsList} />
        <NormalNews list={newsList} />
        {count > newsList.length && (
          <ReadMoreContainer>
            <Line />
            <ReadMoreButton onClick={() => setCurrentPage(currentPage + 1)}>
              더보기
            </ReadMoreButton>
          </ReadMoreContainer>
        )}
      </Content>
    </NewsWrapper>
  );
};
export default News;
